import { VoiceClipPlaceholder } from "@/pages/Voice/types";

export const isSameFile = (firstFile: File, secondFile: File) => firstFile.name === secondFile.name && firstFile.size === secondFile.size;

export const trimStr = (voice: unknown) => (typeof voice === "string" ? voice.trim() : voice);

export const arrLen = (voice: unknown) => (Array.isArray(voice) ? voice.length : 0);

export const hasErroredPlaceholderClips = (clips: unknown) =>
  Array.isArray(clips) && clips.some((clip) => Boolean((clip as VoiceClipPlaceholder)?.failure_reason));
